"use client";

import { motion } from "framer-motion";

const credentials = [
  "ISO 9001 Certified",
  "Ministry of Education",
  "Cambridge Partner",
  "IB World School",
  "Council of Independent Schools",
  "STEM Accredited",
];

export function SocialProof() {
  return (
    <section className="border-y border-border bg-white py-10">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <p className="text-center font-display text-[11px] font-bold uppercase tracking-[0.25em] text-muted-foreground">
          Accredited & Trusted By
        </p>
        <div className="mt-7 grid grid-cols-2 gap-x-6 gap-y-5 md:grid-cols-3 lg:grid-cols-6">
          {credentials.map((c, i) => (
            <motion.div
              key={c}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="flex items-center justify-center"
            >
              <span className="font-display text-xs font-bold uppercase tracking-wider text-navy/70 transition-colors hover:text-navy">
                {c}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
